import React from "react";
import { Link, graphql, useStaticQuery } from "gatsby"
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import "../css/menus.css"
import { Menu } from "antd";

const Menus = () => {
  const data = useStaticQuery(graphql`
      query MenusQuery {

        allPage {

          nodes {
            name
            slug
            publish
          }

        }

        allResources(sort: {fields: position, order: ASC}) {

          nodes {
            name
            redirect
            resource_links {
              name
              url
            }
          }

        }

      }
  `)
  return (
<>

        {data.allPage.nodes.filter(node => node.publish).map(items => (

          <li className="nav-item">
            <Link to={items.slug ? `/${items.slug}` : ""}>{items.name}</Link>
          </li>

        ))}
        <li className="nav-item">
          <Link to="/contact">Contact</Link>
        </li>




            {/* <div class="slide-in-wrap right_slide-in-wrap right_menu_slide-in-wrap">
                <nav role="navigation">
                    <div id="menuToggle">
                        <input type="checkbox" />
                        <div class="menuToggle-wrap">
                            <div class="hamburger-icon">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div class="text-next-to-hamburger">
                                Resources
                            </div>
                        </div>
                        <ul id="menu">
                          <div id="slide-in-wrap_menu-wrap">
                              <div id="right_menu_content">
                                  <ul id="right_menu">

                                        <h3 className="with-underline">Resources</h3>

                                          <Accordion allowZeroExpanded allowMultipleExpanded >

                                          {data.allResources.nodes.map(items => (

                                            <AccordionItem>
                                              <AccordionItemHeading>
                                                <AccordionItemButton>
                                                  {items.name}
                                                </AccordionItemButton>
                                              </AccordionItemHeading>
                                              <AccordionItemPanel>
                                                {items.resource_links.map(items => (
                                                    <a href={items.url} target="_blank" rel="noopener">{items.name}</a>
                                                ))}
                                              </AccordionItemPanel>
                                            </AccordionItem>

                                          ))}

                                          </Accordion>

                                    </ul>
                                </div>
                            </div>
                        </ul>

                    </div>
                </nav>
            </div> */}


</>
  )
}
export default Menus
